import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import styles from "./physician.module.scss";

import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import PhysicianCard from "./PhysicianCard";
import PhysicianView from "./physicianView";
import CardPagination from "../../common/pagination/cardPagination";

import {
  getAllPhysician,
  createPhysician,
  editPhysician,
  deletedPhysician,
  resetCreateMessages,
  resetDeleteMessages,
  resetUpdateMessages,
  associateClinic,
  setCurrentPage,
  setPageLimit,
  resetAssociateClinicMessages,
} from "../../../store/slices/physicianSlice";
import PhsicianAddUpdateModal from "./PhsicianAddUpdateModal";
import { getCitySlice } from "../../../store/slices/citySlice";
import { getAllSpecialization } from "../../../store/slices/specializationSlice";
import { getLanguageSlice } from "../../../store/slices/languageSlice";
import { getEducationSlice } from "../../../store/slices/educationSlice";
import { getTreatmentSlice } from "../../../store/slices/treatmentSlice";
import { FaListUl } from "react-icons/fa";
import { FaUserDoctor } from "react-icons/fa6";
import AssociatePhysicianModal from "./associatePhysicianModal";

const Physician = () => {
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [deletePhysician, setDeletePhysician] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedPhysician, setSelectedPhysician] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [showStatus, setShowStatus] = useState(null);
  const [associateModalVisible, setAssociateModalVisible] = useState(false);
  const [closeAssociateModala, setCloseAssociateModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
    image: false,
  });

  const [formData, setFormData] = useState({
    id: "",
    clinicId: "",
    clinicUserId: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    gender: "",
    experience: 0,
    education: [],
    language: [],
    license: "",
    userType: 2,
    specialization: [],
    specializationId: [],
    city: "",
    cityName: "",
    aboutDoctor: "",
    additionalInfo: "",
    instagram: "",
    facebook: "",
    twitter: "",
    linkedIn: "",
    status: "Active",
    treatments: [],
    verifyPhysician: "No",
    clinicStatus: "Accepted",
    physicianStatus: "Accepted",
  });

  const [associateFormData, setAssociateFormData] = useState({
    physicianId: "",
    physicianName: "",
    clinicId: "",
    clinicUserId: "",
    regularFees: "",
    followupFees: "",
    emergencyFees: "",
    videConsultationFees: "",
    establishmentFees: "",
    clinicStatus: "Accepted",
    physicianStatus: "Accepted",
  });

  const {
    physician,
    currentPage,
    totalPages,
    totalCount,
    limit,
    createPhysicianSuccessMessage,
    createPhysicianErrorMessage,
    updatePhysicianSuccessMessage,
    updatePhysicianErrorMessage,
    deletePhysicianSuccessMessage,
    deletePhysicianErrorMessage,
    associateClinicSuccessMessage,
    associateClinicErrorMessage,
    loading,
  } = useSelector((state) => state.physician);

  const { cities } = useSelector((state) => state.city);
  const { specializations } = useSelector((state) => state.specializations);
  const { languages } = useSelector((state) => state.languages);
  const { educations } = useSelector((state) => state.educations);
  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { treatments } = useSelector((state) => state.treatment);

  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const handlePageChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleCloseAssociateModal = () => {
    setAssociateModalVisible(false);
    setCloseAssociateModal(true);
  };
  const handleDataChange = (e) => {
    const { name, value } = e.target;
    setAssociateFormData({ ...associateFormData, [name]: value });
  };

  const handlePhysicianChange = (data) => {
    setAssociateFormData({
      ...associateFormData,
      physicianId: data.value,
      physicianName: data.label,
    });
  };
  const handleAssociatePhysician = async (e) => {
    e.preventDefault();
    const data = {
      ...associateFormData,
      clinicId,
      clinicUserId: clinicInfo[0]?.userId?._id,
      token,
    };
    await dispatch(associateClinic(data));
    handleCloseAssociateModal();
    setAssociateFormData({
      physicianId: "",
      physicianName: "",
      clinicId: "",
      clinicUserId: "",
      regularFees: "",
      followupFees: "",
      emergencyFees: "",
      videConsultationFees: "",
      establishmentFees: "",
      clinicStatus: "Accepted",
      physicianStatus: "Accepted",
    });
  };
  const handleTabChange = (selectedTab) => {
    setActiveTab(selectedTab);
    setSearchValue("");
  };

  const toggleStatus = (index) => {
    setShowStatus && setShowStatus(showStatus === index ? null : index);
  };

  const handleUpdateStatus = async (status, physicianId) => {
    const data = {
      clinicStatus: status,
      clinicId,
      clinicUserId: clinicInfo[0]?.userId?._id,
      physicianId: physicianId,
      token,
    };
    await dispatch(associateClinic(data));
    setActiveTab(1);
  };

  useEffect(() => {
    if (!clinicId || !token) return;
    const params = {
      clinicId,
      token,
      searchQuery: searchValue,
      currentPage, // Passing current page to API
      limit, // Passing limit to API
      status: "Active",
      physicianStatus: "Accepted",
      clinicStatus: activeTab === 1 ? "Accepted" : "Requested",
    };

    if (!associateModalVisible) {
      dispatch(getAllPhysician(params));
    }
  }, [
    dispatch,
    clinicId,
    activeTab,
    token,
    closeAssociateModala,
    associateModalVisible,
    currentPage,
    limit,
    searchValue,
  ]);

  useEffect(() => {
    dispatch(getCitySlice({ token }));
    dispatch(getAllSpecialization({ token }));
    dispatch(getLanguageSlice({ token }));
    dispatch(getEducationSlice({ token }));
    dispatch(
      getTreatmentSlice({
        status: ["Active"],
        token,
        specializationId: formData?.specializationId,
      }),
    );
  }, [
    dispatch,
    deletePhysician,
    showDeleteModal,
    modalAction,
    modalVisible,
    token,
    formData?.specializationId,
  ]);

  useEffect(() => {
    if (createPhysicianSuccessMessage) {
      showToastifySuccess(createPhysicianSuccessMessage);
      dispatch(resetCreateMessages());
    }
    if (createPhysicianErrorMessage) {
      showToastifyError(createPhysicianErrorMessage);
      dispatch(resetCreateMessages());
    }
    if (updatePhysicianSuccessMessage) {
      showToastifySuccess(updatePhysicianSuccessMessage);
      dispatch(resetUpdateMessages());
    }
    if (updatePhysicianErrorMessage) {
      showToastifyError(updatePhysicianErrorMessage);
      dispatch(resetUpdateMessages());
    }
    if (deletePhysicianSuccessMessage) {
      showToastifySuccess(deletePhysicianSuccessMessage);
      dispatch(resetDeleteMessages());
    }
    if (deletePhysicianErrorMessage) {
      showToastifyError(deletePhysicianErrorMessage);
      dispatch(resetDeleteMessages());
    }
    if (associateClinicSuccessMessage) {
      showToastifySuccess(associateClinicSuccessMessage);
      dispatch(resetAssociateClinicMessages());
    }
    if (associateClinicErrorMessage) {
      showToastifyError(associateClinicErrorMessage);
      dispatch(resetAssociateClinicMessages());
    }
  }, [
    createPhysicianSuccessMessage,
    createPhysicianErrorMessage,
    updatePhysicianSuccessMessage,
    updatePhysicianErrorMessage,
    deletePhysicianSuccessMessage,
    deletePhysicianErrorMessage,
    dispatch,
    associateClinicSuccessMessage,
    associateClinicErrorMessage,
  ]);

  const Genderoptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "TransGender", label: "TransGender" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleModal = (action, physician = null) => {
    if (action === "create") {
      setFormData({
        id: "",
        clinicId,
        clinicUserId: clinicInfo[0]?.userId?._id,
        name: "",
        status: "Active",
        phone: "",
        email: "",
        address: "",
        gender: "",
        education: [],
        experience: 0,
        graduation: "",
        language: [],
        license: "",
        specialization: [],
        specializationId: [],
        city: "",
        cityName: "",
        userType: 2,
        aboutDoctor: "",
        additionalInfo: "",
        instagram: "",
        facebook: "",
        twitter: "",
        linkedIn: "",
        treatments: [],
        verifyPhysician: "No",
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
      });
    } else if (action === "edit" && physician) {
      setFormData({
        id: physician?._id,
        clinicId,
        clinicUserId: clinicInfo[0]?.userId?._id,
        name: physician?.name,
        status: physician?.status,
        phone: physician?.phone,
        email: physician?.email,
        address: physician?.address,
        gender: physician?.gender,
        education: physician?.education,
        experience: physician?.experience,
        language: physician?.language,
        graduation: physician?.graduation,
        license: physician?.license,
        specialization: physician?.specialization,
        city: physician?.city,
        cityName: physician?.cityName,
        userId: physician?.userId?._id,
        aboutDoctor: physician?.aboutDoctor,
        additionalInfo: physician?.additionalInfo,
        instagram: physician?.instagram,
        facebook: physician?.facebook,
        twitter: physician?.twitter,
        linkedIn: physician?.linkedIn,
        treatments: physician?.treatments,
        verifyPhysician: physician?.verifyPhysician,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
      });
    }
    setModalVisible(true);
    setModalAction(action);
  };

  const handleAssociateModal = () => {
    dispatch(getAllPhysician({ token, status: "Active" }));
    setAssociateModalVisible(true);
    setCloseAssociateModal(false);
  };

  const handleFileChange = (file) => {
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        file: file,
      }));
      const previewUrl = URL.createObjectURL(file);
      setImagePreview((prev) => ({
        ...prev,
        file: previewUrl,
      }));
    }
  };

  const handleAddOrUpdatePhysician = async (e) => {
    e.preventDefault();
    const specializationId = formData?.specialization?.map(
      (item) => item.value,
    );
    const educationId = formData?.education?.map((item) => item.value);
    const languageId = formData?.language?.map((item) => item.value);
    const treatmentId = formData?.treatments?.map((item) => item.value);

    try {
      setSubmitLoading(true);
      const { name, email, phNumber, image } = inputError;
      if (name || email || phNumber || image) {
        return;
      } else {
        if (modalAction === "create") {
          await dispatch(
            createPhysician({
              ...formData,
              specialization: specializationId,
              education: educationId,
              language: languageId,
              treatments: treatmentId,
              token,
            }),
          );
        } else {
          await dispatch(
            editPhysician({
              physicianId: formData?.id,
              clinicId,
              clinicUserId: clinicInfo[0].userId._id,
              userId: formData?.userId,
              token,
              updatedData: {
                name: formData?.name,
                phone: formData?.phone,
                email: formData?.email,
                address: formData?.address,
                gender: formData?.gender,
                education: educationId,
                experience: formData?.experience,
                language: languageId,
                graduation: formData?.graduation,
                license: formData?.license,
                specialization: specializationId,
                city: formData?.city,
                aboutDoctor: formData?.aboutDoctor,
                additionalInfo: formData?.additionalInfo,
                instagram: formData?.instagram,
                facebook: formData?.facebook,
                twitter: formData?.twitter,
                linkedIn: formData?.linkedIn,
                status: formData?.status,
                treatments: treatmentId,
                file: formData?.file,
                verifyPhysician: formData?.verifyPhysician,
                clinicStatus: "Accepted",
                physicianStatus: "Accepted",
              },
            }),
          );
        }
        await dispatch(
          getAllPhysician({
            token,
            clinicId,
            status: "Active",
            clinicStatus: "Accepted",
            physicianStatus: "Accepted",
          }),
        );
        setModalVisible(false);
        setFormData({
          id: "",
          clinicId: "",
          clinicUserId: "",
          name: "",
          phone: "",
          email: "",
          address: "",
          gender: "",
          education: [],
          experience: 0,
          language: [],
          graduation: "",
          license: "",
          specialization: [],
          city: "",
          userType: 2,
          aboutDoctor: "",
          additionalInfo: "",
          instagram: "",
          facebook: "",
          twitter: "",
          linkedIn: "",
          status: "Active",
          treatments: [],
          verifyPhysician: "No",
          clinicStatus: "Accepted",
          physicianStatus: "Accepted",
        });
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
    finally {
      setSubmitLoading(false);
    }
  };

  const handleEdit = (physician) => {
    const specializationList = physician?.specialization?.map((item) => ({
      value: item?._id,
      label: item?.specialization,
    }));
    const educationList = physician?.education?.map((item) => ({
      value: item?._id,
      label: item?.educationName,
    }));
    const languageList = physician?.language?.map((item) => ({
      value: item?._id,
      label: item?.name,
    }));
    const treatmentList = physician?.treatments?.map((item) => ({
      value: item?._id,
      label: item?.treatmentName,
    }));
    setFormData({
      id: physician?._id,
      clinicId: clinicId,
      clinicUserId: clinicInfo[0]?.userId?._id,
      name: physician.userId?.name,
      phone: physician?.userId?.phone,
      email: physician?.userId?.email,
      address: physician?.userId?.address,
      gender: physician?.userId?.gender,
      education: educationList,
      graduation: physician?.graduation,
      experience: physician?.experience,
      language: languageList,
      license: physician?.license,
      specialization: specializationList,
      city: physician?.userId?.city?._id,
      cityName: physician?.userId?.city?.name,
      status: physician?.status,
      aboutDoctor: physician?.aboutDoctor,
      additionalInfo: physician?.additionalInfo,
      instagram: physician?.instagram,
      facebook: physician?.facebook,
      twitter: physician?.twitter,
      linkedIn: physician?.linkedIn,
      treatments: treatmentList,
      file: physician?.signature,
      verifyPhysician: physician?.verifyPhysician,
      clinicStatus: "Accepted",
      physicianStatus: "Accepted",
    });
    setModalAction("edit");
    setModalVisible(true);
  };

  const handleDelete = (physician) => {
    setDeleteModalVisible(true);
    setDeletePhysician(physician);
  };

  const handleDeletePhysicianConfirm = async () => {
    try {
      await dispatch(
        deletedPhysician({
          physicianId: deletePhysician?._id,
          clinicId,
          token,
        }),
      );
      setDeleteModalVisible(false);
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchValue(value);
    dispatch(setCurrentPage(1));
    if (activeTab === 1) {
      await dispatch(
        getAllPhysician({
          searchQuery: value,
          clinicId,
          clinicStatus: "Accepted",
          physicianStatus: "Accepted",
          token,
        }),
      );
    } else if (activeTab === 2) {
      await dispatch(
        getAllPhysician({
          searchQuery: value,
          clinicId,
          clinicStatus: "Requested",
          physicianStatus: "Accepted",
          token,
        }),
      );
    }
  };

  const handleSelectChange = (selectedOption, name) => {
    if (name === "city") {
      setFormData({
        ...formData,
        city: selectedOption.value,
        cityName: selectedOption.label,
      });
    } else if (name === "specialization") {
      const selectedSpecialization = selectedOption?.map((option) => ({
        value: option?.value,
        label: option?.label,
      }));
      const specializationIds = selectedSpecialization?.map(
        (item) => item?.value,
      );
      setFormData({
        ...formData,
        specialization: selectedSpecialization,
        specializationId: specializationIds,
      });
    } else if (name === "language") {
      const selectedLanguage = selectedOption?.map((option) => ({
        value: option?.value,
        label: option?.label,
      }));
      setFormData({
        ...formData,
        language: selectedLanguage,
      });
    } else if (name === "educations") {
      const selectedEducation = selectedOption?.map((option) => ({
        value: option?.value,
        label: option?.label,
      }));
      setFormData({
        ...formData,
        education: selectedEducation,
      });
    } else if (name === "treatments") {
      const selectedTreatments = selectedOption?.map((option) => ({
        value: option?.value,
        label: option?.label,
      }));
      setFormData({
        ...formData,
        treatments: selectedTreatments,
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: selectedOption.value,
      }));
    }
  };

  const handleShowGlobalViewModal = (physician) => {
    setSelectedPhysician(physician);
    setShowViewModal(true);
  };
  const handleCloseView = () => {
    setShowViewModal(false);
    setSelectedPhysician(null);
  };

  const tabData = [
    { name: "Physician List", icon: FaListUl, id: 1 },
    { name: "Physician Request", icon: FaUserDoctor, id: 2 },
  ];
  return (
    <>
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <div className="profile-tab">
              <div className="custom-tab-1">
                <div className={styles["tabWrapper"]}>
                  {tabData?.map((tab, i) => (
                    <div
                      className={
                        activeTab === tab.id
                          ? styles["tabContentActive"]
                          : styles["tabContent"]
                      }
                      onClick={() => handleTabChange(tab.id)}
                      key={tab.id + i}
                    >
                      <tab.icon />
                      <h5>{tab.name}</h5>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PhysicianCard
        physician={physician}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleSearch={handleSearch}
        addModal={() => handleModal("create")}
        searchValue={searchValue}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        languages={languages}
        educations={educations}
        activeTab={activeTab}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        toggleStatus={toggleStatus}
        handleUpdateStatus={handleUpdateStatus}
        handleAssociateModal={handleAssociateModal}
        isLoading={loading}
      />
      <CardPagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={limit}
        onPageChange={handlePageChange}
      />

      <PhsicianAddUpdateModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        formData={formData}
        handleAddOrUpdatePhysician={handleAddOrUpdatePhysician}
        setFormData={setFormData}
        handleChange={handleChange}
        handleSelectChange={handleSelectChange}
        cities={cities}
        Genderoptions={Genderoptions}
        specializations={specializations}
        languages={languages}
        educations={educations}
        treatments={treatments}
        handleFileChange={handleFileChange}
        imagePreview={imagePreview}
        setInputError={setInputError}
        submitLoading={submitLoading}
        modalAction={modalAction}
      />

      <AssociatePhysicianModal
        associateModalVisible={associateModalVisible}
        handleCloseAssociateModal={handleCloseAssociateModal}
        physician={physician}
        associateFormData={associateFormData}
        setAssociateFormData={setAssociateFormData}
        handleDataChange={handleDataChange}
        handleAssociatePhysician={handleAssociatePhysician}
        handlePhysicianChange={handlePhysicianChange}
      />

      <PhysicianView
        physician={selectedPhysician}
        show={showViewModal}
        handleClose={handleCloseView}
      />

      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">Delete Physician</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to delete this Physician?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModalVisible(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDeletePhysicianConfirm}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Physician;
